import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';

const purebabySizes: string[] = [
  'Newborn - 00000',
  'Newborn - 0000',
  '0-3 Months - 000',
  '3-6 Months - 00',
  '6-12 Months - 0 ',
  '1 Year - 1',
  '2 Years - 2',
  '3 Years - 3',
  '4 Years - 4',
  '5 Years - 5',
  'XS ',
  'XS-S',
  'S',
  'S-M',
  'M',
  'M-L',
  'L',
  'OS',
];

export const purebabyShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getBrandDirectFilterConfig(),
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: purebabySizes,
    }),
  ],
};
